import UploadingFiles from './UploadingFiles.component';

export default UploadingFiles;